import ColumnAdderRight from "./ColumnAdderRight";
import ColumnAdderLeft from "./ColumnAdderLeft";
import ContextTrace from "./ContextTrace";
import G from './Getters';
import A from './ActionCreators';
import { useContext, useMemo, useRef, useState, useReducer, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TextRowAdder from './TextRowAdder';
import ManualAnnotationGridTable from './ManualAnnotationGridTable';

import GridScrollContainer from './GridScrollContainer';

import HorizontallyTranslatableGridContainer from './HorizontallyTranslatableGridContainer';

import { produce } from 'immer'




import { 
  GridBoundaryAdjustmentContext, 
  ColumnResizeContext,
  CropAdjustmentContext,
  RowDragContext,
  ContextMenuContext,
} from './Contexts';
import { FigureModalArgs } from './FigureInteractionProvider';

const eventOnCropResizer = e => {

  let path = e.composedPath();

  if( path.includes && path.some(comp => comp.className && comp.className.includes && comp.className.includes('crop-resizer')) ){
    return true;
  }
  return false

}





const DEFAULT_DRAG_RECT = { rectStart:[],intersections:[], rect:null }

const DEFAULT_STATE = () => ({
  //cellDragEntered:[-10,-10],
  mouseIsDown:false,
  lastClickDragArea:0,
  dontUnselectCells:false,
  dragRectInfo:DEFAULT_DRAG_RECT,
})

function reducer(state,setAction){
  return produce(state,draft => {
    for(let prop in setAction ){
      let val = setAction[prop];
      draft[prop] = val;
    }
  })
}




export default function NewManualAnnotationGrid({
  rows,
  cols,
  figurePanelId,
  tableOutlineShowing,
}){

  const columnResizeContext = useContext(ColumnResizeContext);
  let { currentWidths } = columnResizeContext;
  const modalArgs = useContext(FigureModalArgs);
  const editable = !Boolean(modalArgs);

  let [ cropResizeInfo, setCropResizeInfo ] = useState();

  if( !figurePanelId ){
    throw Error("ManualAnnotationGrid MUST be passed a 'figurePanelId'");
  }

  const [ localState, localDispatch ] = useReducer(reducer, DEFAULT_STATE());

  let { 
    mouseIsDown,
  } = localState;


  const dispatch = useDispatch();

  const onMouseDown = e => {

    if( e.which === 3 || eventOnTopToolbar(e) || eventOnCropResizer(e) || eventOnRowDragButton(e) ){

      return;
    }

    //e.stopPropagation();

  }

  const onMouseUp = e => {

    if( e.which === 3 || eventOnTopToolbar(e) ){
      return;
    }


    if( !mouseIsDown ){

      let path = e.composedPath();

      let classNames = Array.from(path).map(ele => ele.className);
      let tagNames = Array.from(path).map(ele => ele.tagName);
      if( classNames.some((cl,ii) => {
        if( typeof(cl) !== 'string' ){
          return false;
        }
        let hasBadTag = ['INPUT','TEXTAREA'].includes(tagNames[ii]);


        //without these classes, we'd clear the current 
        //figureItemSelection
        let hasBadClass = ['sg-context-menu', 'MuiListItem-root','value-textarea','style-toolbar','grid','toolbar-button','crop-resizer','figure-info-sidebar'].some(x => cl.includes(x));


        let badPropertyMappings = {
          filesystemcontainer:'crops',
          action:'rowDragButton',
          //valuetype:"crop-expansion",
        }

        let hasBadPropertyMapping = Object.entries(badPropertyMappings).some(([key,value]) => path[ii].getAttribute(key) === value);

        let matchesSkips = hasBadTag || hasBadClass || hasBadPropertyMapping;

        let elementIdsToCheckIntersection = ['figure-info-sidebar'];

        if( !matchesSkips ){

          if(elementIdsToCheckIntersection.findIndex(id => {
            let ele = document.querySelector('#'+id);
            if( ele ){
              let bounds = ele.getBoundingClientRect();

              let leftX = bounds.left;
              let rightX = bounds.left + bounds.width;
              let top = bounds.top;
              let bottom = bounds.top + bounds.height;

              let inX = leftX <= e.clientX && e.clientX <= rightX;
              let inY = top <= e.clientY && e.clientY <= bottom;

              let inBounds = inX && inY;
              if( inBounds ){
                return true;
              }else{
                //;
              }

            }
          }) !== -1){
            return true;
          }


        }else{
          return matchesSkips;
        }


      }) ){

        return;
      }else{
      }
      return; 
    }

  }



  const onMouseMove = e => {

    let X = e.clientX;
    let Y = e.clientY

    if( cropResizeInfo ){

      let { 
        side,
        startX, 
        startY, 
        inlineCrop, 
        tempInlineCrop,
        cellLocation,
        cellWidthOfCropBeingAdjusted,
        annotation,
        globalState
      } = cropResizeInfo;


      let deltaX = X - startX;
      let deltaY = Y - startY;

      let leftButtonIsDown = e.buttons === 1;
      if( !leftButtonIsDown ){
        return;
      }


      let adjustingHorizontally = ['left','right'].includes(side);

      //let deltaY = e.clientY - adjustingCrop.yStart;

      if( side === 'bottom' ){
      }else if( side === 'top' ){
      }else if( adjustingHorizontally ){
        return;

      }else if( side.includes("rotation") ){

        let change = -(deltaY * inlineCrop.width / cellWidthOfCropBeingAdjusted )
        let fromLeft = side.includes("left") ? 1 : 0;
        let fromRight = fromLeft ? 0 : 1;

        let [p0,p1] = annotation.ls;
        let [ x0, y0 ] = p0;
        let [ x1, y1 ] = p1;

        let newY0 = y0 + change * fromLeft;
        let newY1 = y1 + change * fromRight;

        let newLs = [
          [x0,newY0],
          [x1,newY1]
        ]

        let newInlineCrop = G.getCropFromAnnotation(globalState,annotation._id,{ls:newLs});

        setCropResizeInfo({
          ...cropResizeInfo,
          tempInlineCrop:newInlineCrop,
          annotationChanges:{
            ls:newLs
          }

        })
      }
      return;
    }
  }

  const eventOnRowDragButton = e => {

    let path = e.composedPath();
    let onRowDragButton = path.find(comp => {
      let getAttribute = comp?.getAttribute;

      //document object doesn't have getAttribute function
      if( !getAttribute ){
        return false;
      }
      return getAttribute && comp?.getAttribute('action') === 'rowDragButton'
    })
    /* && comp.className.includes && comp.className.includes('sg-context-menu'));*/

    return onRowDragButton;

  }

  useEffect(() => {

    if( editable !== false ){

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mousedown',onMouseDown);
      window.addEventListener('mouseup', onMouseUp);

      return () => {
        window.removeEventListener('mousedown',onMouseDown);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('mousemove', onMouseMove);
      }
    }
  });



  const editableTableRef = useRef();


  let gridTableProps = useMemo(() => ({
    currentWidths,
    editableTableRef,
    dispatch,
    editable,
    tableOutlineShowing,
    figurePanelId,
    localDispatch,
  }),[currentWidths,
    editableTableRef,
    dispatch,
    editable, tableOutlineShowing,
    figurePanelId,
    localDispatch]
  );


  let [topRowAdder,bottomRowAdder] = [0,rows].map(rowIndex => (
    <TextRowAdder {...{figurePanelId,rowIndex}}/>
  ))

  let leftColumnAdder = <ColumnAdderLeft {...{
    figurePanelId, tableOutlineShowing, rows
  }}/>

  let rightColumnAdder = <ColumnAdderRight {...{
    figurePanelId,
    tableOutlineShowing,
    rows,
    cols,
  }}/>

  let grid = (
    <ManualAnnotationGridTable {...gridTableProps}/>
  )


  let nothing = (<>
      <CropAdjustmentContext.Provider value={{cropResizeInfo,setCropResizeInfo}}>

    </CropAdjustmentContext.Provider>
  </>
  )

  return (
    <>
      

        <div class="sg-row full-width" 
          style={{
            position:'relative',
            minHeight:0,
            minWidth:0,

          }}>


          <HorizontallyTranslatableGridContainer>

            {leftColumnAdder}
            <div class="sg-col" style={{
              //flex:'0 0 auto',
              minWidth:0,
              minHeight:0,
              position:'relative',
            }}>
              {topRowAdder}
              <GridScrollContainer editableTableRef={editableTableRef}>
                {grid}
              </GridScrollContainer>
              {bottomRowAdder}
            </div>

            {rightColumnAdder}


          </HorizontallyTranslatableGridContainer>
        </div>


        <ContextTrace/>
    </>

      //
  )

}





const eventOnTopToolbar = e => {

  let path = e.composedPath();
  let containsToolbar = path.find(comp => comp.id === 'top-editor-toolbar');

  return containsToolbar;

}
